import type { ClickUIElementInputProperties } from '@schibsted/pulse-news-media';
import type { PulseAttributes } from '../../../../core/mandatory-integrations/pulse/utils/index.js';
import type { WrappedTeaser } from './TeaserWrapper.js';

import { createTargetObject } from '../../../../core/mandatory-integrations/pulse/event-data/index.js';

type GetTeaserClickTrackingObject = (params: {
  teaser: WrappedTeaser;
  pulseAttributes: PulseAttributes;
  entityId: string;
  targetUrl: string;
  pageId: string;
  isMobile?: boolean;
  externalSource?: string;
}) => ClickUIElementInputProperties;

export const getTeaserClickTrackingObject: GetTeaserClickTrackingObject = ({
  teaser,
  pulseAttributes,
  entityId,
  targetUrl,
  pageId,
  isMobile,
  externalSource,
}) => {
  const {
    entityType,
    elementPosition,
    entityImageUrl,
    elementPositionInBundle,
    entitySize,
    source,
    elementBundleId,
  } = pulseAttributes;

  return {
    object: {
      id: entityId,
      elementType: entityType || 'ArticleReference',
      name: 'Teaser',
      layout: {
        elementSize: teaser?.size || undefined,
        imageUrl: entityImageUrl,
      },
      page: {
        id: pageId,
        type: 'Listing',
      },
      placement: {
        primaryPosition: elementPosition || 0,
        positionInBundle: elementPositionInBundle,
        source,
      },
      custom: {
        'spt:device': isMobile ? 'phone' : 'desktop',
        'spt:bundleId': elementBundleId,
        ...(entitySize
          ? {
              'spt:height': entitySize.height,
              'spt:width': entitySize.width,
            }
          : {}),
      },
    },
    target: {
      ...createTargetObject(pulseAttributes, externalSource || 'vink'),
      url: targetUrl,
    },
  };
};
